import { ReactNode } from "react";
import { AllIconName, IconType, PlainIcon } from "../../Icon";
import styled from "styled-components";
import { StyledDialogContainer } from "../StyledModalComponents";
import { ModalTestIds } from "../Modal";
import { Title } from "../components";
import { Subtitle } from "../../Text";

const CloseIconContainer = styled.span`
  position: absolute;
  top: 24px;
  right: 0px;
  cursor: pointer;
  > span {
    display: block;
  }
`;

type DialogProps = {
  onClose: () => void;
  children?: ReactNode;
  id?: string;
  testId?: string;
  closeIconId?: string;
  className?: string;
  title: {
    text: string;
    iconName?: AllIconName;
    iconType?: IconType;
    bgColor?: string;
    id?: string;
  };
  subtitle?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- holds any DOM node type
  nodeRef?: React.RefObject<any>;
};

/**
 * This is the small modal that a user can import to have the "default"
 * dialog look.
 */
export const DialogContent = ({
  onClose,
  children,
  className = "",
  testId,
  id,
  closeIconId,
  title,
  subtitle,
  nodeRef,
  ...dialogProps
}: DialogProps) => {
  return (
    <StyledDialogContainer
      className={`${className} small`}
      data-testid={testId ?? ModalTestIds.Container}
      position="absolute"
      id={id}
      ref={nodeRef}
      {...dialogProps}
    >
      <CloseIconContainer>
        <PlainIcon id={closeIconId} iconName="x-close" onClick={onClose} />
      </CloseIconContainer>
      <Title
        titleId={title.id}
        iconName={title.iconName}
        iconType={title.iconType}
      >
        {title.text}
      </Title>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
      {children}
    </StyledDialogContainer>
  );
};
